import React from 'react'
import { Wrapper } from './style'

const Trends = () => {
  return (
    <Wrapper>
    <div>
  {/*begin::Row*/}
  <div className="row gy-5 g-xl-5">
    {/*begin::Col*/}
    <div className="col-xxl-12">
      {/*begin::Tables Widget 9*/}
      <div className="card card-xxl-stretch mb-5 mb-xl-8">
        {/*begin::Header*/}
        <div className="card-header border-bottom-dashed">
          <h3 className="card-title fw-bolder">Trends</h3>
          <div className="card-toolbar">
          </div>
        </div>
        {/*end::Header*/}
        {/*begin::Body*/}
        <div className="card-body py-2">
          {/*begin::Table container*/}
          <div className="table-responsive">
            {/*begin::Table*/}
            <table className="table table-row-dashed table-row-gray-300 align-middle gs-4 gy-4">
              {/*begin::Table head*/}
              <thead>
                <tr className="fw-bolder text-dark bg-cus">
                  <th className="w-50px">#</th>
                  <th className="min-w-175px ">Product Details</th>
                  <th className="min-w-125px ">Chart</th>
                  <th className="min-w-150px ">December / 23</th>
                  <th className="min-w-150px ">November / 23</th>
                  <th className="min-w-150px ">October / 23</th>
                  <th className="min-w-150px ">September / 23</th>
                  <th className="min-w-150px ">August / 23</th>
                  <th className="min-w-150px ">June / 23</th>
                  <th className="min-w-150px ">May / 23</th>
                  <th className="min-w-150px ">April / 23</th>
                  <th className="min-w-150px ">March / 23</th>
                  <th className="min-w-150px ">February / 23</th>
                  <th className="min-w-150px ">January / 23</th>
                  <th className="min-w-125px ">Total</th>
                </tr>
              </thead>
              {/*end::Table head*/}
              {/*begin::Table body*/}
              <tbody>
                <tr>
                  <td>1</td>
                  <td>
                    <div className="d-flex align-items-center bdr-left-tbl bg-gray-200 rounded-4 p-3 py-2">
                      <div className="symbol symbol-55px overflow-hidden me-3">
                        <img src="assets/media/dummy.jpg" alt />
                      </div>
                      {/*end::Avatar*/}
                      {/*begin::User details*/}
                      <div className="d-flex flex-column">
                        <a href className="text-gray-800 fs-6 text-hover-danger mb-1 fw-bolder text-one min-w-200px">Paper
                          Jewelry Earring Storage Box Red
                          22....</a>
                        <div className="fs-7 mt-2"><span><b>SKU:</b>
                            AS33ASKK30</span> /
                          <span><b>ASIN:</b> B0XMXUPXX</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div id="kt_table_widget_14_chart_3" className="h-50px mt-n8 pe-7" data-kt-chart-color="danger" style={{minHeight: 50}} />
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$104.93<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$104.93<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$68.90<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center fw-bold fs-6">
                      $168.90</div>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>
                    <div className="d-flex align-items-center bdr-left-tbl bg-gray-200 rounded-4 p-3 py-2">
                      <div className="symbol symbol-55px overflow-hidden me-3">
                        <img src="assets/media/dummy.jpg" alt />
                      </div>
                      {/*end::Avatar*/}
                      {/*begin::User details*/}
                      <div className="d-flex flex-column">
                        <a href className="text-gray-800 fs-6 text-hover-danger mb-1 fw-bolder text-one min-w-200px">Paper
                          Jewelry Earring Storage Box Red
                          22....</a>
                        <div className="fs-7 mt-2"><span><b>SKU:</b>
                            AS33ASKK30</span> /
                          <span><b>ASIN:</b> B0XMXUPXX</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div id="kt_table_widget_14_chart_2" className="h-50px mt-n8 pe-7" data-kt-chart-color="danger" style={{minHeight: 50}} />
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$104.93<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$104.93<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$68.90<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center fw-bold fs-6">
                      $168.90</div>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>
                    <div className="d-flex align-items-center bdr-left-tbl bg-gray-200 rounded-4 p-3 py-2">
                      <div className="symbol symbol-55px overflow-hidden me-3">
                        <img src="assets/media/dummy.jpg" alt />
                      </div>
                      {/*end::Avatar*/}
                      {/*begin::User details*/}
                      <div className="d-flex flex-column">
                        <a href className="text-gray-800 fs-6 text-hover-danger mb-1 fw-bolder text-one min-w-200px">Paper
                          Jewelry Earring Storage Box Red
                          22....</a>
                        <div className="fs-7 mt-2"><span><b>SKU:</b>
                            AS33ASKK30</span> /
                          <span><b>ASIN:</b> B0XMXUPXX</span>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div id="kt_table_widget_14_chart_4" className="h-50px mt-n8 pe-7" data-kt-chart-color="danger" style={{minHeight: 50}} />
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$104.93<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$104.93<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$0.00<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">$68.90<span className="ms-2 badge badge-light-success fs-base">+600%</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center fw-bold fs-6">
                      $168.90</div>
                  </td>
                </tr>
              </tbody>
              {/*end::Table body*/}
            </table>
            {/*end::Table*/}
          </div>
          {/*end::Table container*/}
        </div>
        {/*begin::Body*/}
      </div>
      {/*end::Tables Widget 9*/}
    </div>
    {/*end::Col*/}
  </div>
  {/*end::Row*/}
  {/*begin::Row*/}
  <div className="row gy-5 g-xl-5">
    {/*begin::Col*/}
    <div className="col-xxl-12">
      {/*begin::Tables Widget 9*/}
      <div className="card card-xxl-stretch mb-5 mb-xl-8">
        {/*begin::Body*/}
        <div className="card-body py-2">
          {/*end::Table container*/}
          <div className="d-flex flex-stack flex-wrap pt-0 mt-5">
            <div className="fs-7 fw-bold text-gray-700 d-flex align-items-center">
              <select name aria-controls className="form-select form-select-sm form-select-solid w-75px me-3">
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>Showing 1 to 4 of 4 entries
            </div>
            {/*begin::Pages*/}
            <ul className="pagination">
              <li className="page-item previous">
                <a href="#" className="page-link">
                  <i className="previous" />
                </a>
              </li>
              <li className="page-item active">
                <a href="#" className="page-link">1</a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">2</a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">3</a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">4</a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">5</a>
              </li>
              <li className="page-item">
                <a href="#" className="page-link">6</a>
              </li>
              <li className="page-item next">
                <a href="#" className="page-link">
                  <i className="next" />
                </a>
              </li>
            </ul>
            {/*end::Pages*/}
          </div>
        </div>
        {/*begin::Body*/}
      </div>
      {/*end::Tables Widget 9*/}
    </div>
    {/*end::Col*/}
  </div>
  {/*end::Row*/}
</div>


    </Wrapper>
  )
}

export default Trends